import { render, staticRenderFns } from "./UEeditor.vue?vue&type=template&id=efa9b4a2&scoped=true"
import script from "./UEeditor.vue?vue&type=script&lang=js"
export * from "./UEeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa9b4a2",
  null
  
)

export default component.exports